import React, { useState, useEffect } from 'react';

import { Button } from 'react-bootstrap';
import ModalResult from '../../../facturotopia/ModalResult';

const TicketRequestSearchDownload = (props) => {
  const [download, setDownload] = useState(false);

  useEffect(() => {

  }, [download])

  const handleOnActionDownload = () => {
    const { result } = props.result;

    window.location = result.link;

    setDownload(true);

    props.onChangeDownloadSucces();
  }

  const handleOnClose = () => {
    setDownload(true);

    props.onChangeDownloadSucces();
  }

  return (
    <>
      {!download &&
        <div className="result-container">
        <ModalResult status="success"
            title="Factura emitida."
            subtitle="Si quieres descargar tu factura haz click en Descargar. Si quieres facturar otro ticket haz click en cerrar"
            extra={ (
              <>
              <Button type="button" varian="primary"
                onClick={ handleOnActionDownload }>
                { "Descargar" }
              </Button>

              <Button type="button" variant="secondary"
                onClick={ handleOnClose }>
                { "Cerrar" }
              </Button>
              </>
            )}
          >
          </ModalResult>
      </div>
      }
    </>
  );
}

export default TicketRequestSearchDownload;